module.exports = __webpack_public_path__ + "static/progress-27fdf631c7846667eb4027d02b3631e0.png";